"use strict";

/* eslint no-console: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateByProduct = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var activateByProduct = function activateByProduct(productType) {
  return _apiClient.default.post('upgrade-catalog/v1/catalog/activation', {
    data: {
      productType: productType
    }
  });
};

exports.activateByProduct = activateByProduct;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/api/activateByProduct.js
// module id = 771
// module chunks = 5 6